module.exports = "/_next/static/images/gy-41725ef911e93869236cfdb1a89ec32c.svg";